import { render, staticRenderFns } from "./TripShareSlideOver.vue?vue&type=template&id=3d970cc2"
import script from "./TripShareSlideOver.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripShareSlideOver.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports